import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Subject } from 'rxjs';
import { ISeasonWeek } from 'app/models/ISeasonWeek';
import { IOdds } from 'app/models/IOdd';

@Injectable()
export class OddsService {

  public odds: Subject<IOdds> = new Subject<IOdds>();


  constructor(private baseService: BaseService) { }

  getOdds(seasonWeek: ISeasonWeek) {
    return this.baseService.sendHttpGet('/nfl/getOdds', seasonWeek);  
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/odds.service.ts